import {
  SortDestinationColor,
  SortDestinationColorSchema,
} from "@redotech/redo-fulfillment-wms-common/schema/sort-destination";
import { SortDispositionSchema } from "@redotech/redo-fulfillment-wms-common/schema/sort-disposition";
import { inventoryRuleConditionsSchema } from "@redotech/redo-inventory-common/inventory-rules/conditions";
import { sortDestinationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const createSortDestination = {
  name: "createSortDestination" as const,
  input: z.object({
    name: z.string(),
    disposition: SortDispositionSchema.optional(),
    conditions: inventoryRuleConditionsSchema.optional(),
    color: SortDestinationColorSchema.default(SortDestinationColor.white),
  }),
  output: z.object({
    id: sortDestinationIdFormat.schema,
    priority: z.number().int(),
    conditions: inventoryRuleConditionsSchema.nullable(),
    disposition: SortDispositionSchema.nullable(),
  }),
};
